export const CONSENT_COOKIE_NAME = 'ifixit_consent';
export const CONSENT_COOKIE_EXPIRY_DAYS = 395;

export const CONSENT_ACCEPTED = 1;
export const CONSENT_REJECTED = 0;
export const CONSENT_PENDING = -1;

export type ConsentValue =
   | typeof CONSENT_ACCEPTED
   | typeof CONSENT_REJECTED
   | typeof CONSENT_PENDING;

export interface IFixitConsentCookie {
   isConsented: ConsentValue;
}

export type ConsentDecision = 'accepted' | 'rejected' | 'pending';
